<template>
  <svg class="app-ctrl-svg-icon" xmlns="http://www.w3.org/2000/svg" width="34.297" height="28.197" viewBox="0 0 34.297 28.197">
    <g id="Icon_ionic-md-chatboxes" data-name="Icon ionic-md-chatboxes" transform="translate(1.25 1.25)">
      <path id="Pfad_40" data-name="Pfad 40" d="M13.542,10.623l0-7.092,11.1.095v13.15H20.976v4.808l-5.69-4.808H4V10.51Z"
            transform="translate(7.149 2.67)" fill="none" stroke-width="2.5"/>
      <path id="Pfad_39" data-name="Pfad 39" d="M24.648,3.648H4V16.8H7.668v4.808l5.69-4.808H24.648Z"
            transform="translate(-3.996 -3.648)" fill="none" stroke-width="2.5"/>
    </g>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>